import React from "react";
import { useSelector } from "react-redux";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function BackDrop() {
  const loaderStatus = useSelector((state) => state?.commonReducer?.showLoader);
  return (
    <Backdrop
      sx={{
        color: "#00000",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "rgba(0, 0, 0, 0.2)",
      }}
      open={loaderStatus || false}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
